import { ErrorCode, FileRejection } from 'react-dropzone';

import { notificationsActions } from '@sv-support-sdk/store';

import type { TThunk } from '../index';
import { notificationActions as notificationActionsSlices } from '../slices/notifications';
import { $l } from '../../locales';

export const showSomethingWentWrongError = (): TThunk => (dispatch) => {
  dispatch(
    notificationsActions.notifyError({
      title: $l('ALERTS.ERROR_TITLE'),
      message: $l('ALERTS.SOMETHING_WENT_WRONG'),
    }),
  );
};

export const showFileDropError =
  (fileRejections: FileRejection[]): TThunk =>
  (dispatch) => {
    const isSizeError = fileRejections.some((fileRejection) =>
      fileRejection.errors.some((error) => error.code === ErrorCode.FileTooLarge),
    );

    if (isSizeError) {
      dispatch(
        notificationsActions.notifyWarning({
          title: $l('ALERTS.WARNING_TITLE'),
          message: $l('ALERTS.FILE_IS_TOO_BIG'),
        }),
      );
    } else {
      dispatch(showSomethingWentWrongError());
    }
  };

export default {
  ...notificationActionsSlices,
  ...notificationsActions,
};
